var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "170px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "95%",
      "margin": "0 2%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "staff_name"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("姓名：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入姓名",
      "size": "small"
    },
    model: {
      value: (_vm.from.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_name", $$v)
      },
      expression: "from.staff_name"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "staff_gender"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("性别：")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.from.staff_gender),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_gender", $$v)
      },
      expression: "from.staff_gender"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.from.staff_gender),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_gender", $$v)
      },
      expression: "from.staff_gender"
    }
  }, [_vm._v("女")])], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "staff_card"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("身份证号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入身份证号",
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.from.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_card", $$v)
      },
      expression: "from.staff_card"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("出生日期：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择出生日期",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.from.birth_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "birth_date", $$v)
      },
      expression: "from.birth_date"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("年龄：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入年龄",
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.from.age),
      callback: function($$v) {
        _vm.$set(_vm.from, "age", $$v)
      },
      expression: "from.age"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "staff_telephone"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("手机号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入手机号",
      "size": "small"
    },
    model: {
      value: (_vm.from.staff_telephone),
      callback: function($$v) {
        _vm.$set(_vm.from, "staff_telephone", $$v)
      },
      expression: "from.staff_telephone"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("民族：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入民族",
      "size": "small"
    },
    model: {
      value: (_vm.from.nation),
      callback: function($$v) {
        _vm.$set(_vm.from, "nation", $$v)
      },
      expression: "from.nation"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("籍贯：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入籍贯",
      "size": "small"
    },
    model: {
      value: (_vm.from.native_place),
      callback: function($$v) {
        _vm.$set(_vm.from, "native_place", $$v)
      },
      expression: "from.native_place"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("身份证地址：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入身份证地址",
      "size": "small"
    },
    model: {
      value: (_vm.from.card_address),
      callback: function($$v) {
        _vm.$set(_vm.from, "card_address", $$v)
      },
      expression: "from.card_address"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("现居住地地址：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入现居住地地址",
      "size": "small"
    },
    model: {
      value: (_vm.from.residence),
      callback: function($$v) {
        _vm.$set(_vm.from, "residence", $$v)
      },
      expression: "from.residence"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("户口所在地：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入户口所在地",
      "size": "small"
    },
    model: {
      value: (_vm.from.domicile_place),
      callback: function($$v) {
        _vm.$set(_vm.from, "domicile_place", $$v)
      },
      expression: "from.domicile_place"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("户籍性质：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择户籍性质",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.household_register_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "household_register_id", $$v)
      },
      expression: "from.household_register_id"
    }
  }, _vm._l((_vm.householdRegisterList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("银行卡号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入银行卡号",
      "size": "small"
    },
    model: {
      value: (_vm.from.bank_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "bank_no", $$v)
      },
      expression: "from.bank_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("第一学历：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择第一学历",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.first_degree_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "first_degree_id", $$v)
      },
      expression: "from.first_degree_id"
    }
  }, _vm._l((_vm.firstDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("最高学历：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择最高学历",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.second_degree_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "second_degree_id", $$v)
      },
      expression: "from.second_degree_id"
    }
  }, _vm._l((_vm.secondDegreeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("健康状况：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择健康状况",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.health_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "health_id", $$v)
      },
      expression: "from.health_id"
    }
  }, _vm._l((_vm.healthList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("邮箱：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入邮箱",
      "size": "small"
    },
    model: {
      value: (_vm.from.mailbox),
      callback: function($$v) {
        _vm.$set(_vm.from, "mailbox", $$v)
      },
      expression: "from.mailbox"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("微信：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入微信",
      "size": "small"
    },
    model: {
      value: (_vm.from.we_chat),
      callback: function($$v) {
        _vm.$set(_vm.from, "we_chat", $$v)
      },
      expression: "from.we_chat"
    }
  })], 2)], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c35baf","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabsEdit/basic.vue
// module id = null
// module chunks = 